import type { CandidateFilters } from '@/types/candidate';
import type { KanbanFeature } from '@/types/kanban';

const startOfDay = (date: Date) => {
  const value = new Date(date);
  value.setHours(0, 0, 0, 0);
  return value.getTime();
};

const endOfDay = (date: Date) => {
  const value = new Date(date);
  value.setHours(23, 59, 59, 999);
  return value.getTime();
};

const toDate = (value: Date | string) =>
  value instanceof Date ? value : new Date(value);

export const matchesCandidateFilters = (
  feature: KanbanFeature,
  filters: CandidateFilters
) => {
  const { tags, status, dateRange } = filters;

  if (tags.length) {
    const featureTags = feature.tags ?? [];
    const hasTag = tags.some((tag) => featureTags.includes(tag));
    if (!hasTag) {
      return false;
    }
  }

  if (status && feature.column !== status) {
    return false;
  }

  if (dateRange.from || dateRange.to) {
    const submittedAt = toDate(feature.startAt).getTime();

    if (dateRange.from && submittedAt < startOfDay(dateRange.from)) {
      return false;
    }

    if (dateRange.to && submittedAt > endOfDay(dateRange.to)) {
      return false;
    }
  }

  return true;
};
